import React from "react";
import GrComponentFactory from "../gr_component_factory";
import classnames from "classnames";
import { nextTransitionMessage, prevTransitionMessage } from "../../modules/carousel/carousel_helper";

export default GrComponentFactory.createClass({

  displayName: "NextArrow",

  propTypes: {
    carouselId: React.PropTypes.string.isRequired,
    currentSlide: React.PropTypes.number,
    slideCount: React.PropTypes.number,
    carouselSlidesToShow: React.PropTypes.number,
    carouselWrapAround: React.PropTypes.bool,
    clickHandler: React.PropTypes.func,
    carouselReverseScroll: React.PropTypes.bool,
    smTopOffset: React.PropTypes.number,
    trackRef: React.PropTypes.object,
  },

  clickHandler (options, e) {
    e.preventDefault();
    this.props.clickHandler(options, e);
  },

  render () {
    const message = this.props.carouselReverseScroll ? prevTransitionMessage : nextTransitionMessage;
    let nextHandler = this.clickHandler.bind(this, { message });
    const nextClasses = ["gr-carousel__arrow", "gr-carousel__arrow--next"];

    if (this.props.carouselReverseScroll) {
      if (!this.props.carouselWrapAround && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.carouselSlidesToShow)) {
        nextClasses.push("gr-carousel__arrow--disabled");
        nextHandler = null;
      }
    } else {
      if (!this.props.carouselWrapAround) {
        if (this.props.currentSlide >= (this.props.slideCount - this.props.carouselSlidesToShow)) {
          nextClasses.push("gr-carousel__arrow--disabled");nextHandler = null;
        }
        if (this.props.slideCount <= this.props.carouselSlidesToShow) {
          nextClasses.push("gr-carousel__arrow--disabled");nextHandler = null;
        }
      }
    }
    const nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: classnames(nextClasses),
      style: {top: `${this.props.smTopOffset}px`},
      onClick: nextHandler,
    };
    return (<div><button aria-label="Next" type="button" {...nextArrowProps} /></div>);
  },
});
